
























































































































































































































import Vue from "vue";
import Component from "vue-class-component";
import store, { RoleStore, LoadingSpinnerService } from "@/store";
import { UserStore } from "@/store";
import { ContactProfileDto } from "@/api/ClientPortalApiClient";
import { FindUserRolesQuery } from "@/api/AuthenticationApiClient";
import ApiFactory from "@/api/ApiFactory";
import { getModule } from "vuex-module-decorators";
import AlertService from "@/services/alert.service";
import { Prop } from "vue-property-decorator";

@Component
export default class ProfileWidget extends Vue {
  @Prop() contactId: number | undefined;

  private profile: ContactProfileDto | null = new ContactProfileDto();
  private message: string = "test";
  private clientSelectorID: number = 1;
  private alertService = new AlertService();

  private async created() {
    await this.loadContactProfile();
    this.clientSelectorID = UserStore.clientSelectorId;
  }

  private async loadContactProfile() {
    LoadingSpinnerService.Show("Loading your profile...");
    const apiClient = ApiFactory.CreateDataClient();

    try {
      this.profile = await apiClient.profile_getByContactId(
        this.contactId || UserStore.profileId
      );
      LoadingSpinnerService.Hide();
    } catch (e) {
      LoadingSpinnerService.Failure("Unable to load your profile");
    }
  }

  get ownerEmail(): string {
    return this.profile ? this.profile.ownerEmail || "" : "";
  }
}
